export default __webpack_public_path__ + "static/media/star-icon.01f38344.svg";